import React from 'react';
import { Link } from 'gatsby';
import { withPrefix } from 'gatsby';
const DownloadAppSection = () => {
  return (
    <div>
      {" "}
      <section className="bg-contain bg-app-section-pattern-2">
        <div className="max-w-[1050px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="flex items-end lg:items-center justify-center lg:justify-start pt-12 lg:pt-0 lg:min-h-[500px]">
              <div className="">
                <img
                  className="object-cover h-[380px]  sm:h-[450px] lg:-mb-12"
                  src={"/images/iphone-12-pro.png"}
                  alt="get on playstore"
                />
              </div>
            </div>
            <div className="row-start-1 lg:col-start-2 flex items-center justify-center mt-20 lg:justify-start lg:my-0">
              <div className="space-y-10 lg:-ml-20 sm:space-y-5">
                <h2
                  className="text-white text-center lg:text-left text-2xl leading-[28px] lg:text-[50px] lg:leading-[60px] font-bold lg:mb-3"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  Download the App Today
                </h2>
                <div
                  className="flex justify-start mt-14 space-x-7 lg:space-x-11"
                  data-aos="fade-up"
                  data-aos-delay="150"
                  data-aos-duration="1000"
                >
                  <Link to="https://play.google.com/store/apps/details?id=com.jeetar.superapp">
                    <button className="h-[3.8rem] w-[8.9rem]  px-5 py-3 bg-white rounded-xl overflow-hidden">
                      <img
                        className="object-cover w-24"
                        src={"/images/black-google-store.png"}
                        alt="get on playstore"
                      />
                    </button>
                  </Link>
                  <Link to="https://apps.apple.com/us/app/jeetar/id1599147708">
                    <button className="h-[3.8rem] w-[8.9rem]  px-5 py-3 bg-white rounded-xl overflow-hidden">
                      <img
                        className="object-cover w-24"
                        src={"/images/black-apple-store.png"}
                        alt="get on appstore"
                      />
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DownloadAppSection;
